import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import AppLayout from './components/layout/AppLayout';
import Login from './pages/Login';
import Jobs from './pages/Jobs';
import Archive from './pages/Archive';
import Reports from './pages/Reports';
import JobReports from './pages/JobReports';
import Users from './pages/Users';
import Clients from './pages/Clients';
import Categories from './pages/Categories';
import Statuses from './pages/Statuses';
import Spinner from './components/shared/Spinner';

const Private = ({ children, roles }) => {
  const { user, loading } = useAuth();
  if (loading) return <Spinner fullscreen />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role))
    return <Navigate to="/" replace />;
  return children;
};

export default function App() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" /> : <Login />} />
      <Route path="/" element={<Private><AppLayout /></Private>}>
        <Route index element={<Navigate to="/jobs" replace />} />
        <Route path="jobs" element={<Jobs />} />
        <Route path="archive" element={<Archive />} />
        <Route path="reports" element={
          <Private roles={['super_admin', 'manager']}><JobReports /></Private>
        } />
        <Route path="dashboard" element={
          <Private roles={['super_admin', 'manager']}><Reports /></Private>
        } />
        <Route path="users" element={
          <Private roles={['super_admin']}><Users /></Private>
        } />
        <Route path="clients" element={
          <Private roles={['super_admin']}><Clients /></Private>
        } />
        <Route path="categories" element={
          <Private roles={['super_admin']}><Categories /></Private>
        } />
        <Route path="statuses" element={
          <Private roles={['super_admin']}><Statuses /></Private>
        } />
      </Route>
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}
